webpackJsonp([263791100135453],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/about-header-big.c4e6ca6a.jpg";

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/about-header-small.551d2960.jpg";

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-white.0fe52734.svg";

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Layout = __webpack_require__(7);
	
	var _logoWhite = __webpack_require__(114);
	
	var _logoWhite2 = _interopRequireDefault(_logoWhite);
	
	var _feather = __webpack_require__(39);
	
	var _feather2 = _interopRequireDefault(_feather);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Linkedin from "../../assets/linkedin"
	
	var footerStyle = /*#__PURE__*/(0, _reactEmotion.css)("overflow:hidden;background-color:", _colors2.default.black, ";color:rgba(255,255,255,0.8);text-align:center;& img{display:block;margin:0;}");
	
	var ulStyle = /*#__PURE__*/(0, _reactEmotion.css)("list-style-type:none;margin:0;margin-bottom:1.45rem;text-transform:uppercase;& a{cursor:pointer;opacity:0.8;transition:opacity 0.10s ease-in;transition:color 0.10s ease-in;&:hover{text-decoration:none;box-shadow:none;opacity:1;transition:opacity 0.10s ease-in;}}& li{margin:0;}& a svg{stroke:white;}");
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-1kttejr0"
	})("width:100%;margin:0;@media (min-width:832px){width:75%;margin 0 auto;}");
	
	var socialList = /*#__PURE__*/(0, _reactEmotion.css)("display:flex;justify-content:space-between;list-style-type:none;margin:0;");
	
	var mySvg = /*#__PURE__*/(0, _reactEmotion.css)("opacity:0.5;transition:opacity 0.15s ease-in;transition:color 0.15s ease-in;&:hover{text-decoration:none;box-shadow:none;opacity:1;transition:opacity 0.15s ease-in;}");
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "div",
	    { className: footerStyle },
	    _react2.default.createElement(
	      _Layout.Box,
	      { p: [3, 3, 4], align: "left", color: "white" },
	      _react2.default.createElement(
	        _Layout.Flex,
	        { wrap: ["wrap", "wrap", "nowrap"], justify: "space-between" },
	        _react2.default.createElement(
	          _Layout.Box,
	          { width: [1, 1, 1 / 3] },
	          _react2.default.createElement(
	            Wrapper,
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement("img", { src: _logoWhite2.default, height: "50px", alt: "PCS Logo" }),
	              _react2.default.createElement(
	                "p",
	                null,
	                props.name
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Layout.Box,
	          { width: [1, 1, 1 / 3] },
	          _react2.default.createElement(
	            Wrapper,
	            null,
	            _react2.default.createElement(
	              "ul",
	              { className: ulStyle },
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/locations" },
	                  "Locations"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/privacy" },
	                  "Privacy Policy"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/terms" },
	                  "Terms of Service"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/contact" },
	                  "Contact Us"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Layout.Box,
	          { width: [1, 1, 1 / 3] },
	          _react2.default.createElement(
	            Wrapper,
	            null,
	            _react2.default.createElement(
	              "ul",
	              { className: socialList },
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  { title: "Link to our Facebook page", href: "https://www.facebook.com/preferredcablingsystems", target: "_blank", rel: "noopener" },
	                  (0, _feather2.default)("facebook", ["30", "30"], mySvg)
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  { title: "Link to our linkedin account", href: props.linkedin, target: "_blank", rel: "noopener" },
	                  (0, _feather2.default)("linkedin", ["30", "30"], mySvg)
	                )
	              ),
	              _react2.default.createElement(
	                "a",
	                { title: "Our E-Mail address", href: "mailto:" + props.email },
	                (0, _feather2.default)("mail", ["30", "30"], mySvg)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Wrapper,
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "PCS installs single & multi-mode fiber, Cat3, Cat5, Cat5E, Cat6, and RG6 cable.",
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement(
	                "span",
	                null,
	                "Phone:"
	              ),
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "tel:" + props.phone },
	                "877-307-8131"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Copyright \xA9 2018 " + props.name + ". All rights reserved."
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emotion = __webpack_require__(49);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _logo = __webpack_require__(115);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var basicNav = /*#__PURE__*/(0, _emotion.css)("display:flex;position:fixed;top:0;align-items:center;background-color:white;margin:0;width:100%;padding:0.25rem 32px;list-style-type:none;-webkit-box-shadow:0px 2px 15px 1px rgba(99,99,99,0.8);-moz-box-shadow:0px 2px 15px 1px rgba(99,99,99,0.8);box-shadow:0px 2px 15px 1px rgba(99,99,99,0.8);z-index:9998;height:3.5rem;@media (min-width:832px){padding:0.25rem 64px;}");
	
	var linkStyle = /*#__PURE__*/(0, _emotion.css)("color:inherit;font-weight:600;&:hover{cursor:pointer;}");
	
	var fullNav = /*#__PURE__*/(0, _emotion.css)(basicNav, ";display:none;& li{margin:0;}& li img{display:inline-block;vertical-align:middle;}& div{display:flex;min-width:28em;justify-content:space-between;margin-left:auto;}& div a{", linkStyle, ";}@media (min-width:991px){display:flex;}");
	
	var mobileNav = /*#__PURE__*/(0, _emotion.css)(basicNav, ";& li{margin:0;}& li:last-child{margin-left:auto;font-weight:600;}& li img{display:block;margin:auto;}@media (min-width:991px){display:none;}");
	
	var mobileStyle = /*#__PURE__*/(0, _emotion.css)("position:fixed;background-color:white;display:block;padding:2rem;width:100%;height:100%;top:0;left:0;right:0;bottom:0;z-index:9999;& ul{list-style-type:none;margin:3rem 0 0 0;height:100%;text-align:center;font-size:1.5rem;}& ul li{margin-top:2rem;}& ul li a{", linkStyle, ";}& div{font-weight:600;text-align:right;}");
	
	var MobileNav = function (_Component) {
	  _inherits(MobileNav, _Component);
	
	  function MobileNav(props) {
	    _classCallCheck(this, MobileNav);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.mobileContainer = document.createElement("div");
	    document.body.appendChild(_this.mobileContainer);
	    return _this;
	  }
	
	  MobileNav.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.body.removeChild(this.mobileContainer);
	  };
	
	  MobileNav.prototype.render = function render() {
	    return _reactDom2.default.createPortal(_react2.default.createElement(
	      "nav",
	      { className: mobileStyle },
	      _react2.default.createElement(
	        "div",
	        { onClick: this.props.toggleNav },
	        "X"
	      ),
	      this.props.children
	    ), this.mobileContainer);
	  };
	
	  return MobileNav;
	}(_react.Component);
	
	var Navigation = function (_Component2) {
	  _inherits(Navigation, _Component2);
	
	  function Navigation(props) {
	    _classCallCheck(this, Navigation);
	
	    var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props));
	
	    _this2.state = {
	      mobileActive: false
	    };
	    _this2.toggleNav = _this2.toggleNav.bind(_this2);
	    return _this2;
	  }
	
	  Navigation.prototype.toggleNav = function toggleNav() {
	    if (this.state.mobileActive) {
	      this.setState({ mobileActive: false });
	    } else {
	      this.setState({ mobileActive: true });
	    }
	  };
	
	  Navigation.prototype.render = function render() {
	    return _react2.default.createElement(
	      "nav",
	      null,
	      _react2.default.createElement(
	        "ul",
	        { className: fullNav },
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement("img", { alt: "PCS Logo", src: _logo2.default, width: "150px", height: "150px" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" },
	              "Home"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/about" },
	              "About Us"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/team" },
	              "Team"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/projects" },
	              "Projects"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/career" },
	              "Careers"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/contact" },
	              "Contact"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: mobileNav },
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement("img", { alt: "PCS Logo", src: _logo2.default, width: "90px", height: "90px" }),
	          " "
	        ),
	        _react2.default.createElement(
	          "li",
	          { onClick: this.toggleNav },
	          "MENU"
	        ),
	        this.state.mobileActive && _react2.default.createElement(
	          MobileNav,
	          { toggleNav: this.toggleNav },
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              { onClick: this.toggleNav },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/" },
	                "Home"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { onClick: this.toggleNav },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/contact" },
	                "Contact"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { onClick: this.toggleNav },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/about" },
	                "About Us"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { onClick: this.toggleNav },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/team" },
	                "Team"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { onClick: this.toggleNav },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/projects" },
	                "Projects"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { onClick: this.toggleNav },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/career" },
	                "Careers"
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	module.exports = exports["default"];

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navigation = __webpack_require__(69);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Footer = __webpack_require__(68);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(104);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SEO = __webpack_require__(26);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _config = __webpack_require__(52);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Layout = __webpack_require__(7);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Hero = __webpack_require__(12);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _aboutHeaderBig = __webpack_require__(108);
	
	var _aboutHeaderBig2 = _interopRequireDefault(_aboutHeaderBig);
	
	var _aboutHeaderSmall = __webpack_require__(109);
	
	var _aboutHeaderSmall2 = _interopRequireDefault(_aboutHeaderSmall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var data = _ref.data;
	    var _data$allBusinessJson = data.allBusinessJson.edges[0].node,
	        social_links = _data$allBusinessJson.social_links,
	        header = _data$allBusinessJson.header,
	        locations = _data$allBusinessJson.locations;
	
	    var myTitle = 'Data Network Design, Cat6, Cat5, Fiber Optic Specialists | PCS';
	    var myDesc = 'Preferred Cabling Systems has been installing data networks, cat5, cat6, and fiber optic cabling for over 25 years. PCS are BDA and DAS installation experts.';
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_SEO2.default, { title: myTitle,
	            description: myDesc
	        }),
	        _react2.default.createElement(_Navigation2.default, { name: header.title }),
	        _react2.default.createElement(
	            _Hero2.default,
	            { imageBig: _aboutHeaderBig2.default, imageSmall: _aboutHeaderSmall2.default },
	            _react2.default.createElement(
	                _Layout.Box,
	                { color: "white", p: [3, 3, 3], align: "left" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    " Data Network & Fiber Optics Specialists "
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Layout.Box,
	            { color: _colors2.default.black,
	                py: "2rem",
	                pl: ["2em", "4em", "6em", "20em"],
	                pr: ["2em", "4em", "6em", "20em"],
	                align: "left" },
	            _react2.default.createElement(
	                "h2",
	                { id: "preferredcablingsystems--wearedata" },
	                "Preferred Cabling Systems \u2013 We Are Data"
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Since Preferred Cabling Systems founding in 1990, the company has thrived under Mike Harrison\u2019s leadership (President & Founder) bursting into a nationwide IT Network brand that offers a broad range of Network Data Solutions which we ensure is maintained after installation."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "We make it easy for our clients by specializing in everything from design to engineering to implementation, we\u2019ve got you covered. We want our clients to feel they have the help they need, which is why we are always here to help. We have client representatives on standby to help with design, data and communication needs."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Our highly qualified engineering division will work alongside our clients and developers to outline the Low Voltage design on projects, making sure that all systems are code compliant with federal, state and local mandates."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "With over 25 years experience in every aspect of Broadband and network architecture, PCS is an easy choice for anything from public Wi-Fi projects to network fiber-optic lines to software upgrades and even integration. We even provide computers and end users with 24/7/365 support spanning to institutions across the nation; hospitality, medical as well as government operations."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Though not limited to, here are some service offerings:"
	            ),
	            _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Telecommunications"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Structured Cabling"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Bi-Directional Antenna (BDA)"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Distributed Antenna Systems (DAS)"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Fiber Optic Splicing"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Fiber Optics Installation"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Cat5e, Cat6, and Cat7"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Security Cameras and Entry Access"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Hotel Network Design"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Low Voltage Integrator"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Telephone Switches, HP Switches and Cisco Switches"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Fire Alarm installation"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Notifier Fire Alarms and"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Nurse Call"
	                )
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "PCS is also a leader in the provision of Fiber To The Office (FTTO), Fiber To The Room (FTTR) and Fiber To The Home(FTTH): . We provide services in the Building Automation Fields. This is generally explained in the context of Internet Of Things (ION)."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Contact us today so we can help you meet your Data and Network needs, and learn why ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "We Are Data"
	                ),
	                "."
	            )
	        )
	    );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-7e3da3823d1f70cf7a38.js